export const supportedLocales: string[] = ["en", "en-GB", "es_ES"];
export const defaultLocale: string = "en";
